/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { Input, Checkbox, Button, Modal, Form } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { basePath } from "../../../api/config";
import axios from "axios";

const Signup = (props) => {
  const { setVisibleRegister, visibleRegister, perfilCuenta } = props;

  const [form] = Form.useForm();
  let email = "";
  const [ botonDeshabilitado, setBotonDeshabilitado ] = useState(false);

  useEffect(() => {
    if (!visibleRegister) {
      form.resetFields();
    }
  },[form, visibleRegister] );

  //Funciones para comparar y validar que los dos correos son iguales
  const compareToFirstEmail = (rule, value) => {
    if (value && value !== form.getFieldValue("email")) {
      return Promise.reject("¡Los correos no coinciden!");
    } else {
      return Promise.resolve();
    }
  };

  //Funciones para comparar y validar que las dos contraseñas son iguales
  const compareToFirstPassword = (rule, value) => {
    if (value && value !== form.getFieldValue("password")) {
      return Promise.reject("¡Las contraseñas no coinciden!");
    } else {
      return Promise.resolve();
    }
  };

  function error(mensaje) {
    Modal.error({
      title: "Creación de cuenta",
      content: (
        <div>
          <p>{mensaje}</p>
        </div>
      ),
      okText: "Entendido",
    });
  }
  function errorExistenteActivo(mensaje) {
    Modal.error({
      title: "Creación de cuenta",
      content: (
        <div>
          <p>{mensaje}</p>
          <p>Recupera tu contraseña</p>
          <a href="/portal/recovery">¿Olvidaste tu contraseña?</a>
        </div>
      ),
      okText: "Entendido",
    });
  }

  function errorExistenteNoActivo(mensaje) {
    Modal.error({
      title: "Creación de cuenta",
      content: (
        <div>
          <p>Cuenta ya registrada</p>
          <p>
            <a href="#!" onClick={resend}>
              Reenviar correo de confirmación
            </a>
          </p>
          <br />
          <p>
          Te recomendamos revisar la <strong>bandeja de entrada, spam o correo no deseado</strong> desde tu correo electrónico.
          </p>
        </div>
      ),
      okText: "Entendido",
    });
  }

  function sucess() {
    Modal.success({
      title: perfilCuenta === 1 ? <center><h1>Registro de ciudadanía</h1></center>
        : <center><h1>Registro de organización</h1></center>,
      icon: false,
      okButtonProps: { style: { display: "block", width: "100%" } },
      content: (
        <div>
          <span style={{ textAlign: "center" }}>
            <CheckCircleOutlined
              style={{
                color: "#E149A4",
                fontSize: "40px",
                textAlign: "center",
                display: "block",
              }}
            />
          </span>
          <br />
          <p>Enviamos un correo para validar tu cuenta.</p>
          <p>Te recomendamos revisar tu <strong>correo no deseado o spam</strong>.</p>
          <br/>
          <hr />
          <p>
            ¿No lo has recibido?
            <a href="#!" onClick={resend}>
              Reenviar correo.
            </a>
          </p>
        </div>
      ),
      okText: "Entendido",
    });
  }

  function sucessEmail() {
    email = "";
    Modal.success({
      title: "Reenvío de correo",
      content: (
        <div>
          <span style={{ textAlign: "center" }}>
            <CheckCircleOutlined
              style={{
                color: "#E149A4",
                fontSize: "40px",
                textAlign: "center",
                display: "block",
              }}
            />
          </span>
          <p>Enviamos un correo para validar tu cuenta</p>
          <br />
          <p>
          Te recomendamos revisar la <strong>bandeja de entrada, spam o correo no deseado</strong> desde tu correo electrónico.
          </p>
        </div>
      ),
      okText: "Ok",
    });
  }

  //Función de reenvio del correo
  const resend = () => {
    if (email !== "") {
      const url = `${basePath}/resendEmail`;
      axios.post(url, { correo: email }).then((response) => {
        const { code } = response.data;
        if (code === 400 || code === 500) {
          //Modal con el error
          const mensaje = response.data.causa;
          error(mensaje);
          email = "";
        } else {
          //const mensaje = response.data.message;
          sucessEmail();
          email = "";
        }
      });
    }
  };

  //Función para procesar los datos del registro.
  const register = () => {
    let values = form.getFieldsValue();
    values.perfilCuenta = perfilCuenta;
    setBotonDeshabilitado(true);
    const url = `${basePath}/registrarCuentaPortal`;
    axios.post(url, values).then((response) => {
      const { code } = response.data;
      if (code === 400 || code === 500) {
        //Modal con el error
        const mensaje = response.data.causa;
        const status = response.data.status;
        if (status === "Cuenta Registrada Activa") {
          errorExistenteActivo(mensaje);
        } else if (status === "Cuenta Registrada No Activa") {
          email = mensaje;
          errorExistenteNoActivo();
        } else {
          error(mensaje);
        }
        setVisibleRegister(false);
      } else {
        const respuesta = response.data.cuenta.correoElectronico;
        email = respuesta;
        setVisibleRegister(false);
        sucess();
      }
      setBotonDeshabilitado(false);
    });
  };

  const validateCheckAcuerdo = (rule, value) => {
    if(!value) {
      form.setFieldsValue({
        acuerdo: undefined,
      });
    }
    return Promise.resolve();
  };

  return (
    <>
      <Form form={form} onFinish={register} layout="vertical">
        <Form.Item label="Correo electrónico"
          name="email"
          dependencies={['confirm']}
          rules= {[
            {
              type: "email",
              message: "El correo no es válido.",
            },
            { required: true, message: "Dato requerido." },
            {/*validator: validateNextEmail*/},
          ]}>
          <Input 
            name="email" 
            autoComplete="off" 
            placeholder="nombre@dominio.com" 
            style={{ textTransform: "lowercase"}} />
        </Form.Item>
        <Form.Item label="Confirma tu correo electrónico"
          name="confirm"
          dependencies={['email']}
          rules= {[
            {
              type: "email",
              message: "El correo no es válido.",
            },
            { required: true, message: "Dato requerido" },
            {validator: compareToFirstEmail},
          ]}>
          <Input autoComplete="off" placeholder="Confirmar correo" style={{ textTransform: "lowercase"}} />
        </Form.Item>
        <Form.Item label="Contraseña" style={{ marginBottom:"0px"}}
          name="password"
          dependencies={['confirmPass']}
          rules= {[
            { required: true, message: "Dato requerido" },
            {
              message: "Ingresa una contraseña válida",
              pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!(){}@¡#,.:;^\\¿/?$%&=*_\-+=[\]|]).{11,}/,
              //pattern: /^(?=.*\d)[0-9a-zA-Z]{6,}$/,
            },
          ]}>
            <Input.Password placeholder="Contraseña" />
        </Form.Item>
        <p style={{ fontSize: "14px" }}>
          Debe contener al menos 11 caracteres e incluir al menos un carácter especial (@¡!#,.:;^()\¿/?$%&=*_-|+[]),
          una letra mayúscula, una letra minúscula y un número.
        </p>
        <Form.Item label="Confirma tu contraseña"
          name="confirmPass"
          dependencies={['password']}
            rules= {[
              { required: true, message: "Dato requerido" },
              { validator: compareToFirstPassword },
            ]}>
          <Input.Password placeholder="Confirmar contraseña" />
        </Form.Item>
        <Form.Item
          name="acuerdo"
            rules={[
              {
                required: true,
                message: "¡Debes aceptar el aviso de privacidad!",
              },
              { validator: validateCheckAcuerdo },
            ]}
            valuePropName = "checked"
            >
            <Checkbox>
              Acepto el{" "}
              <a
                href="https://www.ine.mx/wp-content/uploads/2023/08/DEOE_Aviso_de_privacidad_simplificado_Sistema_de_Observadoras_y_Observadores_Electorales.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                aviso de privacidad
              </a>
              {" "}y que sean enviadas notificaciones al correo electrónico que he proporcionado
            </Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: "100%" }} disabled={botonDeshabilitado}>
            Regístrate
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

const registerForm = Signup;
export default registerForm;
